import React from 'react'
import Header from './Header';
import Content from './Content';
import NavBar from './Navbar/Navbar';
import Footer from './Footer/Footer';

import  './UserDashboard';


function UserDashboard() {
  return (
    <div className='prelogin'>
      <NavBar />
      <Content />
      <Footer />
     
    </div>
  )
}

export default UserDashboard

